import { memo, useMemo } from "react";
import Select from "react-select";
import DropDownStyles, { selectMenuPortalProps } from "./dropdownStyles";
import { useFishTypes, normalizeFishTypesData } from "../../hooks/queries/useFishTypes";

const FULL_WIDTH_STYLES = {
  ...DropDownStyles,
  container: (base) => ({ ...base, width: "100%" }),
  control: (base, state) => ({
    ...DropDownStyles.control(base, state),
    width: "100%",
    minWidth: 0,
  }),
};

const FishSpeciesDropDownSelection = ({
  onChange,
  selectedValue,
  allowMultiple,
  options,
  fullWidth,
  placeholder = "Select Fish Species",
  noOptionsMessage,
}) => {
  const useProvidedOptions = Array.isArray(options);
  const { data } = useFishTypes({ search: "" }, { enabled: !useProvidedOptions });

  const FishSpeciesOptions = useMemo(() => {
    if (useProvidedOptions) return options;
    return normalizeFishTypesData(data).map((species) => ({
      value: species.id,
      label: species.Name,
    }));
  }, [useProvidedOptions, options, data]);

  const selectStyles = fullWidth ? FULL_WIDTH_STYLES : DropDownStyles;

  return (
    <Select
      value={
        allowMultiple
          ? FishSpeciesOptions.filter((option) => selectedValue?.includes(option.value))
          : FishSpeciesOptions.find((option) => option.value === selectedValue)
      }
      onChange={(selectedOptions) => {
        const values = allowMultiple
          ? selectedOptions ? selectedOptions.map((opt) => opt.value) : []
          : selectedOptions ? selectedOptions.value : null;
        onChange(values);
      }}
      options={FishSpeciesOptions}
      styles={selectStyles}
      isMulti={allowMultiple}
      placeholder={placeholder}
      noOptionsMessage={noOptionsMessage}
      isClearable={true}
      {...selectMenuPortalProps}
    />
  );
};

// Memoized: react-select is expensive to re-render. When many of these live in
// editable tables (stocking rows, etc.), skipping re-renders of unchanged rows
// keeps typing from freezing the page. Callers must pass stable `onChange` /
// `noOptionsMessage` for the memo to take effect.
export default memo(FishSpeciesDropDownSelection);
